/**
 * @generated SignedSource<<3cf365a19705454c2b854155e4f95305>>
 * @relayHash ecdd2aeaf20c000ab01207e92301330e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 32e7a430ac1c69a0aa9f347c6d41dc06565faf5b1a45e45620100feb28b548d7

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type LiveConversationsActivityStatusIndicatorQuery$variables = {
  atlassianAccountId: string;
  cloudId: string;
};
export type LiveConversationsActivityStatusIndicatorQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"LiveConversationsActivityStatusIndicator_query">;
};
export type LiveConversationsActivityStatusIndicatorQuery = {
  response: LiveConversationsActivityStatusIndicatorQuery$data;
  variables: LiveConversationsActivityStatusIndicatorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "atlassianAccountId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v2 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "LiveConversationsActivityStatusIndicatorQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "LiveConversationsActivityStatusIndicator_query"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LiveConversationsActivityStatusIndicatorQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "atlassianAccountId"
          },
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          }
        ],
        "kind": "LinkedField",
        "name": "csm_liveChatAgent",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "name": "liveChatActivity"
              },
              {
                "concreteType": "CustomerServiceSpaceLiveChatActivitiesConnection",
                "kind": "LinkedField",
                "name": "liveChatActivitiesBySpace",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "CustomerServiceSpaceLiveChatActivityEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "concreteType": "CustomerServiceSpaceLiveChatActivity",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "activityStatus"
                          },
                          (v2/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "CustomerServiceLiveChatAgent"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "identifier"
              },
              {
                "kind": "ScalarField",
                "name": "message"
              },
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "statusCode"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "errorType"
                  }
                ]
              }
            ],
            "type": "QueryError"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "32e7a430ac1c69a0aa9f347c6d41dc06565faf5b1a45e45620100feb28b548d7",
    "metadata": {},
    "name": "LiveConversationsActivityStatusIndicatorQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "efe950b928b22c116a6e322a0c828642";

export default node;
